import {
    Directive,
    Input
} from '@angular/core';

/**
 * Updates styles when a form group has been submitted
 * Styles target using the [formGroup] attribute.
 */
@Directive({
    selector: '[payFormSubmitted]',
    standalone: false,
    host: {
        '[class.is-submitted]': 'submitted === true'
    }
})
export class FormSubmittedDirective {

    @Input('payFormSubmitted') public submitted: boolean = false;

    constructor() {
    }
}
